import { Avatar, Tooltip } from "@mui/material";
import React from "react";
import { EMPTY_VALUE, INVITE_STATUS_ENUM } from "../../Utils/constants";
import { Spinner } from "../UI";
import "./inboxCard.scss";

const STATUS_META = {
  accepted: { label: "Accepted", className: "ok" },
  declined: { label: "Declined", className: "no" },
  auto: { label: "Auto declined", className: "muted" },
  pending: { label: "Pending", className: "wait" },
};

function InboxCard({ user, data, type, ...props }) {
  const status = data?.invitationStatus;
  const isReceived = type === INVITE_STATUS_ENUM.RECEIVED;
  const isAccepted =
    status === INVITE_STATUS_ENUM.USER_ACCEPTED ||
    status === INVITE_STATUS_ENUM.SYSTEM_ACCEPTED;
  const isRejected = status === INVITE_STATUS_ENUM.REJECTED;
  const isAutoRejected = status === INVITE_STATUS_ENUM.SYSTEM_REJECTED;

  const meta = isAccepted
    ? STATUS_META.accepted
    : isRejected
    ? STATUS_META.declined
    : isAutoRejected
    ? STATUS_META.auto
    : STATUS_META.pending;

  const name = `${data?.firstName ?? ""} ${data?.lastName ?? ""}`.trim();
  const imageKey = Object.keys(data?.imageUrl ?? {})[0];

  const openProfile = () => {
    if (!!data?.id) {
      props.history.push(`/my-matches/${data?.firstName?.replace(" ", "-")}`, {
        data,
        pathname: "/my-inbox/",
        filterInfo: props?.filterPayload,
      });
    }
  };

  const viewContact = (handler, disabled, tip) => (
    <Tooltip title={tip ?? ""} arrow disableHoverListener={!tip}>
      <span className="inbox-action-wrap">
        <button
          type="button"
          className="inbox-btn primary"
          disabled={disabled}
          onClick={handler}
        >
          View contact
        </button>
      </span>
    </Tooltip>
  );

  const actions = () => {
    if (isAccepted) return viewContact(() => props?.fetchContacts());
    if (isRejected) return null;
    if (isReceived) {
      return (
        <>
          <button
            type="button"
            className="inbox-btn success"
            onClick={() => props?.AcceptInvite()}
          >
            Accept
          </button>
          {!isAutoRejected && (
            <button
              type="button"
              className="inbox-btn danger"
              onClick={() => props?.RejectInvite()}
            >
              Decline
            </button>
          )}
        </>
      );
    }
    if (isAutoRejected) {
      return (
        <>
          <button
            type="button"
            className="inbox-btn danger"
            onClick={() => props?.CancelInvite()}
          >
            Cancel
          </button>
          <Tooltip title="Auto declined invite" arrow>
            <span className="inbox-action-wrap">
              <button
                type="button"
                className="inbox-btn success"
                onClick={() => props?.SendInvitation()}
              >
                Resend invite
              </button>
            </span>
          </Tooltip>
        </>
      );
    }
    return (
      <>
        <button
          type="button"
          className="inbox-btn danger"
          onClick={() => props?.CancelInvite()}
        >
          Cancel
        </button>
        {viewContact(
          () => props?.fetchPrimeContacts(),
          !user?.prime,
          "Only for PRIME Users"
        )}
      </>
    );
  };

  return (
    <Spinner loading={props?.loading}>
      <div className={`inbox-card ${meta.className}`}>
        <div
          role="link"
          tabIndex={0}
          className="inbox-card-main"
          onClick={openProfile}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openProfile(e);
            }
          }}
          aria-label={`Open profile of ${name}`}
        >
          <Avatar
            alt={name || "a"}
            className="inbox-avatar"
            src={imageKey ? data?.imageUrl[imageKey] : EMPTY_VALUE}
          />
          <div className="inbox-info">
            <div className="inbox-name" title={name}>
              {name || EMPTY_VALUE}
            </div>
            <div className="inbox-meta">
              <span>ID {data?.id ?? EMPTY_VALUE}</span>
              <span>{data?.location ?? "-"}</span>
              <span>Age {data?.age ?? EMPTY_VALUE}</span>
            </div>
            <div className="inbox-edu">
              {data?.higherQualification ?? EMPTY_VALUE}
            </div>
          </div>
        </div>
        <div className="inbox-side">
          <span className={`inbox-status ${meta.className}`}>{meta.label}</span>
          <div className="inbox-actions">{actions()}</div>
        </div>
      </div>
    </Spinner>
  );
}

export default InboxCard;
